module.exports = __webpack_public_path__ + "static/05-991a0871feff58f6d4b523fc31c3d204.jpg";